import { Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

@Component({
  template: '<ftr-help [isLoggedIn]="isLoggedIn"></ftr-help>',
  standalone: false,
})
export class HelpPage {
  isLoggedIn = this.route.snapshot.data?.isLoggedIn

  constructor(private route: ActivatedRoute) {}
}
